import { type ApartmentRequirementProfile } from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
import { sendOutFilters } from '@/app/settings/modules/communication/send-out-templates/filters';

export const ApartmentRequirementProfileItem: RelationFieldProps<ApartmentRequirementProfile> =
  {
    filters: sendOutFilters,
    renderItem: (item) => ({
      title: item?.name ?? '',
      descriptionItems: <></>,
    }),
  };
